import React from 'react';
import ReactDOM from 'react-dom/client';

/* Theme tokens must load before any component CSS */
import './theme/globals/theme-variables.css';
import './theme/globals/rtl-overrides.css';
import './theme/globals/print.css';
import './theme/globals/kpi-animations.css';
import './index.css';

import 'leaflet/dist/leaflet.css';
import './leafletFix';

/* DEV-1257-followup. Tabler icon webfont — registers .ti and .ti-<name>
 * classes so all <i className="ti ti-x" /> refs across the app render.
 * Without this import the icon font is missing and ~13 sites render blank
 * (the close button on Action Center trays was the first one to notice).
 *
 * File lives at dist/tabler-icons.min.css per the @tabler/icons-webfont
 * v3.44 package layout. If a future upgrade reshuffles, check with
 * `ls node_modules/@tabler/icons-webfont/dist/*.css`. */
import '@tabler/icons-webfont/dist/tabler-icons.min.css';

/* DEV-1488. Country flags as bundled SVGs, not emoji. Regional-indicator
 * flag emoji render as flags only on macOS/iOS — Windows and older Android
 * ship no flag glyphs and paint the two ISO letters instead ("US", "GB"),
 * which is what appeared as stray "initials" on avatars for off-Mac viewers.
 * flag-icons vendors the SVGs locally (no external CDN — no per-viewer
 * location ping), registering .fi and .fi-<cc> classes for <CountryFlag>. */
import 'flag-icons/css/flag-icons.min.css';

/* i18n must initialize before components render */
import './i18n/config';

// DEV-940: migrated from HashRouter to BrowserRouter. URLs are now
// real paths (life4earth.com/rotary) instead of hash fragments
// (life4earth.com/#/rotary). Required server-side change: SPA fallback
// for unknown paths must serve index.html so React Router can route
// client-side. Vite dev server does this by default; production
// hosting (Skip-side check) must be configured accordingly.
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './theme';
import { ColorBlindModeProvider } from './theme/colorBlindMode';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ColorBlindModeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ColorBlindModeProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
